import styled from "styled-components";
import { ModalCardCopy, ModalCardTitle } from "../Modal/ModalCard";

export const Title = styled(ModalCardTitle)`
    /* margin-bottom: 12px; */
`;

export const Content = styled(ModalCardCopy)`
    /* margin-bottom: 24px; */
`;
